// ***************************************
// Definition of game token ReplayController
// ***************************************
import { gameController } from "../../game_theme/flow_fb/flowController";
import { tbGame } from "../engine/tbGame";
import { ComponentButton } from "../framework/components/ComponentButton";
import { ComponentLabel } from "../framework/components/ComponentLabel";
import { ComponentPicture } from "../framework/components/ComponentPicture";
import { DialogBase } from "../framework/dialogs/DialogBase";
import { tgfGraphics } from "../framework/tgfGraphics";
import { MiscSettings } from "../settings/Settings";
import { SoundManager } from "../settings/SoundManager";
import { AngryAnalytics } from "./Analytics/Analytics";
import { angrybirds_regular } from "./AssetDefinitions/FontDefinitions";
import { s_black_square, s_popup_darkblue_rect, s_popup_top, s_popup_bottom, s_popup_close, s_icon_close, s_replay_overlay, s_btn_round_orange_small, s_icon_fforward_small } from "./AssetDefinitions/ImageDefinitions";
import { Playback } from "./Playback";
import { playController } from "./gameController";
// The constructor for the ReplayController game token. 
export var ReplayController = function (data, callback, skipCallback) {
    "use strict";
    // Properties used by the engine
    this.visible = true;
    this.active = true;
    // Your own properties
    this.spine = null;
    this.data = data["replay"];
    this.cameraData = data["replayCamera"];
    this.callback = callback;
    this.skipCallback = skipCallback;
    this.delay = 100;
    this.showReplay = false;
    // Add it to the game engine
    tbGame.addToken(this);
    tbGame.addTokenTags(this, ["play"]);
};
// handleAdd is called when the token is (re-) added to the game. 
ReplayController.prototype.handleAdd = function () {
    "use strict";
    var self = this;
    // Hide the additional messages
    playController.uiController.lobbyButtonContainer.hide();
    playController.messageHandler.hideAllMessages();
    playController.waitingForPlayerWithoutDialog = false;
    playController.sceneControllerActivePopUps = true;
    this.inputAllowed = true;
    if (!playController.isIngame) {
        this.dialog = new DialogBase({
            x: tgfGraphics.areaWidth / 2,
            y: tgfGraphics.areaHeight / 2
        });
        var transparentBlack = new ComponentPicture({
            x: -100,
            y: -100,
            xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
            yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
            alpha: 0.7,
            image: s_black_square
        });
        this.dialog.addComponent(transparentBlack);
        this.bg = new ComponentPicture({
            image: s_popup_darkblue_rect,
            createFromSlices: true,
            sliceMarginsArray: [55, 55, 55, 55],
            width: 800,
            height: 470,
            x: -800 / 2,
            y: -235
        }, null);
        this.dialog.addComponent(this.bg);
        this.dialog.addComponent(new ComponentPicture({ image: s_popup_top, x: 0, y: -250 }));
        this.dialog.addComponent(new ComponentPicture({ image: s_popup_bottom, x: 0, y: -250 + 450 }));
        this.subText = new ComponentLabel({
            y: -130,
            text: "PRESS ON THE TV TO WATCH THE \n REPLAY OF YOUR OPPONENT’S SHOTS!",
            font: {
                fontFace: angrybirds_regular.fontFace,
                fontSize: 36,
                fillColor: "#fefefe",
                align: "center",
                baseline: "middle",
                fontWeight: "bold"
            }
        });
        this.dialog.addComponent(this.subText);
        this.textHeading = new ComponentLabel({
            x: 0,
            y: -245,
            text: "IT’S YOUR TURN",
            font: {
                fontFace: angrybirds_regular.fontFace,
                fontSize: 34,
                fillColor: "#fefefe",
                align: "center",
                baseline: "middle"
                //shadow: { active: true, color:'rgba(50, 49, 65, 0.7)', offsetX: 2, offsetY: 3, blur: 1, distance: 4 }
            }
        });
        this.dialog.addComponent(this.textHeading);
        this.buttonRight = new ComponentButton({
            image: s_popup_close,
            icon: s_icon_close,
            iconPosition: "center",
            x: 415,
            y: -218,
            touchMargin: MiscSettings.closeButtonTouchMargin,
            onClick: function () {
                if (self.inputAllowed) {
                    AngryAnalytics.reportReplayHandling(false);
                    SoundManager.playEffect(SoundManager.UI_STATE.EXPLOSION, SoundManager.UICollection, 0, false);
                    playController.waitingForPlayerWithoutDialog = false;
                    playController.messageHandler.hideAllMessages();
                    self.inputAllowed = false;
                    self.callback = null;
                    tbGame.removeToken(self);
                    playController.sceneControllerActivePopUps = false;
                }
            }
        });
        this.dialog.addComponent(this.buttonRight);
        var buttonPlay = new ComponentButton({
            alpha: 0,
            x: 10,
            y: 170,
            icon: s_replay_icon,
            iconPosition: "center",
            onClick: function () {
                if (self.inputAllowed) {
                    self.subText.setText(" ");
                    self.textHeading.setText(" ");
                    self.subText.hide();
                    self.textHeading.hide();
                    self.buttonRight.setAlpha(0);
                    self.buttonRight.hide();
                    SoundManager.playEffect(SoundManager.UI_STATE.REPLAY_TV_EXPLOSION, SoundManager.UICollection, 0, false);
                    playController.waitingForPlayerWithoutDialog = false;
                    playController.messageHandler.hideAllMessages();
                    self.inputAllowed = false;
                    self.playReplayAnimation();
                }
            }
        });
        this.dialog.addComponent(buttonPlay);
        this.dialog.show();
    }
    else {
        this.showReplay = true;
    }
};
// handleRemove is called when the token is removed from the game.
ReplayController.prototype.handleRemove = function () {
    "use strict";
    if (this.dialog) {
        this.dialog.hide();
        this.dialog.free();
    }
    if (this.callback) {
        this.callback(this.data);
    }
    else if (this.skipCallback) {
        this.skipCallback();
    }
    if (this.playback) {
        tbGame.removeToken(this.playback);
    }
};
ReplayController.prototype.playReplayAnimation = function () {
    "use strict";
    var self = this;
    this.spine.repeat = false;
    this.spine.setAnimation("watch_replay_outro", function () {
        self.showReplay = true;
        console.log("play Replay");
    });
};
// handleEndStep is called each step after processing other events (before draw).
ReplayController.prototype.handleEndStep = function (timePassed) {
    "use strict";
    var self = this;
    if (!this.showReplay)
        return;
    if (this.showReplay && this.delay < 0) {
        console.log("replay overlay created");
        if (this.dialog) {
            this.dialog.hide();
            this.dialog.free();
            this.dialog = null;
        }
        this.dialog = new DialogBase({
            x: tgfGraphics.areaWidth / 2,
            y: tgfGraphics.areaHeight / 2
        });
        var recImage = new ComponentPicture({
            image: s_replay_overlay,
            xScale: 2,
            yScale: 2
        });
        this.dialog.addComponent(recImage);
        var buttonRight = new ComponentButton({
            image: s_btn_round_orange_small,
            icon: s_icon_fforward_small,
            iconPosition: "center",
            x: tgfGraphics.areaWidth / 2 - s_btn_round_orange_small.width / 2,
            y: tgfGraphics.areaHeight / 2.4 + s_btn_round_orange_small.height / 2,
            onClick: function () {
                AngryAnalytics.reportReplayHandling(false);
                self.callback = undefined;
                SoundManager.playEffect(SoundManager.UI_STATE.BACK, SoundManager.UICollection, 0, false);
                tbGame.removeToken(self);
            }
        });
        this.dialog.addComponent(buttonRight);
        this.dialog.show();
        //TODO trigger the replay
        this.playback = new Playback(this.data, this.cameraData, this.onReplayEnded.bind(this));
        playController.sceneController.playback = this.playback;
        playController.uiController.lobbyButtonContainer.hide();
        playController.messageHandler.hideAllMessages();
        playController.sceneControllerActivePopUps = false;
        this.showReplay = false;
    }
    else {
        this.delay -= timePassed;
    }
};
ReplayController.prototype.onReplayEnded = function () {
    gameController.transition = null;
    AngryAnalytics.reportReplayHandling(true);
    tbGame.removeToken(this);
};
